import { Dispatch, SetStateAction } from 'react'
import { Badge } from 'reactstrap'
import { renderDateTime } from '../../utils/dateFormatter'
import { UserSummary, VehicleCertQuery } from '../../services/endpoints/service29'

type SortOptionChangedEvent = {
  fullName?: string
  value?: unknown
  component: { columnOption: (index: number, option: string) => unknown }
}
export const certSortOrderFor = (query: VehicleCertQuery, field: string) =>
  query.sort === field ? query.order : undefined

export const handleCertSortChange = (
  e: SortOptionChangedEvent,
  setQuery: Dispatch<SetStateAction<VehicleCertQuery>>,
  baseQuery: VehicleCertQuery
) => {
  const match = e.fullName?.match(/^columns\[(\d+)\]\.sortOrder$/)
  if (!match) return
  const dataField = e.component.columnOption(
    Number(match[1]),
    'dataField'
  ) as string
  const order = e.value as 'asc' | 'desc' | undefined
  setQuery((prev) => ({
    ...prev,
    sort: order ? dataField : baseQuery.sort,
    order: order ?? baseQuery.order,
    offset: 0
  }))
}

export const renderUser = ({ value }: { value: UserSummary | null }) =>
  value ? `${value.username}` : '—'

export const renderDate = ({ value }: { value: string | null }) =>
  value ? renderDateTime({ value }) : '—'

export const makeStatusRenderer =
  (config: Record<string, { label: string; color: string }>) =>
    ({ value }: { value: string }) => {
      const c = config[value] ?? { label: value, color: 'secondary' }
      return <Badge color={c.color}>{c.label}</Badge>
    }
